
import { sendSignatureToServer, getDataNewsletterContent } from '../../shared/data-services/newsletter-service';

export async function sendSignature (signatureId, signature,employeeId){

    const data = await sendSignatureToServer(
                         signatureId,signature,employeeId);
    return data || [];
 };

 export async function getNewsletterContent (newsletetrId){

    const data = await getDataNewsletterContent(newsletetrId);
    return data || [];
 };